import { BaseModel } from './base.model'

import { VehicleRoute, Vehicle } from './vehicle.model'
import { Role } from './role.model'
import { Team } from './team.model'
import { UserStatus } from './user.model'

export class Driver extends BaseModel {
  id: string
  email: string
  lastLoggedAt: Date
  name: string
  phone: string
  lastRoute: VehicleRoute
  vehicle: Exclude<Vehicle, 'groups'>
  picture: string | null
  role: Role
  surname: string
  status: UserStatus
  todayData: TodayData
  team: Team

  get fullName() {
    return `${this.name} ${this.surname}`
  }

  constructor(driver: Driver) {
    super(driver)
    this.picture = this.picture && this.fileUrl + this.picture
  }
}

export type DriverTruncated = Pick<Driver, 'id' | 'fullName'>

export interface TodayData {
  duration: number
  distance: number
}

export enum DriverRouteScope {
  Work = 'work',
  Private = 'private',
}

export const DriverRouteScopeLabel = {
  [DriverRouteScope.Work]: 'CLIENT.MAP.WORK',
  [DriverRouteScope.Private]: 'CLIENT.MAP.PRIVATE',
} as const
